import { z } from 'zod'

import { Permission } from './permission'

import { Pagination } from '@/types/app/request'
import { ManagerBinding } from '@/types/park/manager'

/** Profile containing a group of multiple permissions. */
export const Profile = z.object({
    id: z.number().positive(),
    name: z.string().min(1),
    description: z.string().min(1),
    client: ManagerBinding,
    permissions: Permission.array(),
})

export type Profile = z.infer<typeof Profile>

/** Profile list request. */
export const ProfilesRequest = Pagination.extend({
    results: Profile.array(),
})

export type ProfilesRequest = z.infer<typeof ProfilesRequest>
